import { useHistory, useParams } from 'react-router-dom'
import AppLayout from '../../../../components/layout/layout'
import { Row, Tabs } from 'antd'
import KidProfileHeader from './Header'
import KidBasicInfo from './BasicInfo'
import KidEvents from './Events'
import KidDocuments from './Documents'
import KidActivity from './Activity'
import Notes from '../NotesComp/Notes'
import { useGetKidById } from 'api/family/kid'
import { useEffect } from 'react'
import KidMedia from './Media'
import Spinner from 'components/Spinner'
import { useGetSearchParams } from 'hooks/useGetSearchParams'
const { TabPane } = Tabs

const KidProfile = () => {
  const history = useHistory()
  let { id }: { id: string } = useParams()
  const { tab } = useGetSearchParams(['tab'])
  const { isLoading, isFetching, data, refetch } = useGetKidById(id)

  const handleTabChange = (key: string) => {
    if (key === 'events') {
      history.push(`?tab=events&page=1&limit=20`)
    } else {
      history.push(`?tab=${key}`)
    }
  }

  useEffect(() => {
    refetch()
  }, [id])

  return (
    <AppLayout id={id}>
      <div className="container">
        {isLoading || isFetching ? (
          <div className="h-full w-full flex align-center justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            <KidProfileHeader data={data} refetch={refetch} />
            <Row>
              <Tabs
                activeKey={tab || 'activity'}
                style={{ width: '100%', height: '100%' }}
                className="bg-white profile-tabs"
                onChange={handleTabChange}
              >
                <TabPane tab="Activity" key="activity">
                  <KidActivity />
                </TabPane>
                <TabPane tab="Events" key="events">
                  <KidEvents />
                </TabPane>
                <TabPane tab="Basic info" key="basic-info">
                  <KidBasicInfo data={data} />
                </TabPane>
                <TabPane tab="Media" key="media">
                  <KidMedia />
                </TabPane>
                <TabPane tab="Documents" key="documents">
                  <KidDocuments />
                </TabPane>
                <TabPane tab="Notes" key="notes">
                  <Notes id={id} familyId={data?.familyId} />
                </TabPane>
              </Tabs>
            </Row>
          </>
        )}
      </div>
    </AppLayout>
  )
}
export default KidProfile
